import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { DOM_ID } from '@UILayer/UILayer.types';

// TYPES
import { RC_PROGRESS_BAR_DEFAULTS, TAssetsLoaderState } from './Preloader.types';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

// CSS
import styles from '@UILayer/UILayer.scss';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

//PANELS & VIEWS

const ProgressBar: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [state, setState] = useReducer(
        (state: TAssetsLoaderState, newState: Partial<TAssetsLoaderState>) => ({ ...state, ...newState }),
        RC_PROGRESS_BAR_DEFAULTS
    );

    const { t } = useTranslation();
    const globalStyles = useAppSelector(getGlobalStyles);

    const barContainer = cn(styles.progress_bar_container);
    const barProgress = cn(styles.progress_bar, globalStyles.wcaMode);
    const barValue = cn(styles.progress_bar_value, globalStyles.wcaMode, state.progress !== 100 ? styles.value_shadow : {});

    useEffect(() => {
        EventsCenter.on(EGameEvents.ASSET_LOADER_INFORMATION, (data: Partial<TAssetsLoaderState>) => gameLoaderEvent(data));
    }, []);

    function gameLoaderEvent(data: Partial<TAssetsLoaderState>) {
        if (data.progress) setState({ progress: data.progress * 100 });
        if (data.assetType) setState({ assetType: data.assetType, assetKey: data.assetKey });
        if (data.loaderState) setState({ loaderState: data.loaderState });
    }

    return (
        <>
            <div id={DOM_ID.PRELOADER_CONTAINER} className={barContainer}>
                <div
                    role="progressbar"
                    aria-valuenow={state.progress}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuetext={`${state.progress ? state.progress : 100}%`}
                    aria-busy={state.progress < 100 ? true : false}
                    className={barProgress}
                    aria-description={`${t('WCA_LOADING')}: ${state.progress}%`}
                    style={{ width: `${state.progress}%` }}
                >
                    <span className={barValue} style={{ visibility: state.progress === 100 ? 'hidden' : 'visible' }}>{`${state.progress.toFixed()}%`}</span>
                </div>

                {/* {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).debugTools?.active && (
                    <div className={styles.progress_assets_info} style={{ visibility: state.progress === 100 ? 'hidden' : 'visible' }}>
                        {state.assetType} - {state.assetKey}
                    </div>
                )} */}
            </div>
        </>
    );
};

export default ProgressBar;
